import AdvocacyLanding from 'components/Campaigns/RwdAdvocacy/AdvocacyViews/AdvocacyLanding/AdvocacyLanding';
import { withAdvocacyLandingProps } from 'viewModel/Campaigns/RwdAdvocacy/AdvocacyViews/withAdvocacyLandingProps';

export default withAdvocacyLandingProps(AdvocacyLanding);
